import { utils } from '@febos-io/common';

export const changeExternalPasswordSchema = utils.validator.object().shape({
  email: utils.validator.string()
    .required('This field is required')
});

export default changeExternalPasswordSchema;
